if (!customElements.get('store-pickup-option')) {
  customElements.define(
    'store-pickup-option',
    class StorePickupOption extends HTMLElement {
      constructor() {
        super();
        console.log('StorePickupOption: 初期化開始');
        this.checkbox = this.querySelector('#store-pickup-checkbox');
        this.calendarWrapper = this.querySelector('#store-pickup-calendar-wrapper');
        this.dateInput = this.querySelector('#store-pickup-date');
        this.noticeElement = this.querySelector('#store-pickup-notice');
        this.minDays = parseInt(this.dataset.minDays) || 7;
        this.pickupDate = this.dataset.pickupDate || '';
        this.pickupEnabled = this.dataset.pickupEnabled === 'true';

        console.log('StorePickupOption: データ属性', {
          minDays: this.minDays,
          pickupDate: this.pickupDate,
          pickupEnabled: this.pickupEnabled,
          checkbox: !!this.checkbox,
          calendarWrapper: !!this.calendarWrapper,
          dateInput: !!this.dateInput
        });

        this.init();
      }

      init() {
        // 最小日付を設定
        this.setMinDate();

        // チェックボックスのイベントリスナー
        if (this.checkbox) {
          this.checkbox.addEventListener('change', (e) => {
            this.handleCheckboxChange(e.target.checked);
          });
        }

        // 日付入力のイベントリスナー
        if (this.dateInput) {
          this.dateInput.addEventListener('change', (e) => {
            this.handleDateChange(e.target.value);
          });
        }

        // 初期状態の設定
        if (this.pickupEnabled && this.pickupDate) {
          this.calendarWrapper.style.display = 'block';
          this.dateInput.value = this.pickupDate;
          if (this.noticeElement) {
            this.noticeElement.style.display = 'block';
          }
        }
      }

      setMinDate() {
        if (!this.dateInput) return;

        const today = new Date();
        let minDate = new Date(today);
        minDate.setDate(today.getDate() + this.minDays);

        // 火曜日の場合は次の日（水曜日）に変更
        while (minDate.getDay() === 2) { // 火曜日
          minDate.setDate(minDate.getDate() + 1);
        }

        // YYYY-MM-DD形式に変換
        const year = minDate.getFullYear();
        const month = String(minDate.getMonth() + 1).padStart(2, '0');
        const day = String(minDate.getDate()).padStart(2, '0');
        const minDateString = `${year}-${month}-${day}`;

        this.dateInput.setAttribute('min', minDateString);
      }

      handleCheckboxChange(checked) {
        if (checked) {
          this.calendarWrapper.style.display = 'block';
          if (this.noticeElement) {
            this.noticeElement.style.display = 'block';
          }
          // 日付が未選択の場合は最小日付を設定
          if (!this.dateInput.value) {
            this.setMinDate();
            const minDateValue = this.dateInput.getAttribute('min');
            if (minDateValue) {
              // 最小日付が火曜日でないことを確認
              const minDate = new Date(minDateValue + 'T00:00:00');
              if (minDate.getDay() !== 2) { // 火曜日でない場合のみ設定
                this.dateInput.value = minDateValue;
                this.handleDateChange(minDateValue);
              }
            }
          } else {
            // 既存の日付が火曜日でないことを確認
            const existingDate = new Date(this.dateInput.value + 'T00:00:00');
            if (existingDate.getDay() === 2) { // 火曜日の場合は最小日付に変更
              this.setMinDate();
              const minDateValue = this.dateInput.getAttribute('min');
              if (minDateValue) {
                this.dateInput.value = minDateValue;
                this.handleDateChange(minDateValue);
              }
            }
          }
        } else {
          this.calendarWrapper.style.display = 'none';
          if (this.noticeElement) {
            this.noticeElement.style.display = 'none';
          }
          // カートから店頭受取情報を削除
          this.updateCart(false, '');
        }
      }

      handleDateChange(dateValue) {
        if (!dateValue) return;

        // 火曜日かどうかをチェック
        const selectedDate = new Date(dateValue + 'T00:00:00');
        const dayOfWeek = selectedDate.getDay(); // 0=日曜日, 1=月曜日, ..., 6=土曜日

        if (dayOfWeek === 2) { // 火曜日
          // 火曜日は選択できないため、前の日（月曜日）に変更
          const mondayDate = new Date(selectedDate);
          mondayDate.setDate(selectedDate.getDate() - 1);

          const year = mondayDate.getFullYear();
          const month = String(mondayDate.getMonth() + 1).padStart(2, '0');
          const day = String(mondayDate.getDate()).padStart(2, '0');
          const mondayDateString = `${year}-${month}-${day}`;

          this.dateInput.value = mondayDateString;

          // エラーメッセージを表示
          this.showError('火曜日は定休日のため受取予約できません。別の日付を選択してください。');

          // カートのnoteとattributesを更新（月曜日に変更）
          this.updateCart(true, mondayDateString);
          return;
        }

        // カートのnoteとattributesを更新
        this.updateCart(true, dateValue);
      }

      showError(message) {
        // 既存のエラーメッセージを削除
        const existingError = this.querySelector('.store-pickup-option__error');
        if (existingError) {
          existingError.remove();
        }

        // エラーメッセージを表示
        const errorElement = document.createElement('p');
        errorElement.className = 'store-pickup-option__error';
        errorElement.style.color = 'rgb(220, 38, 38)';
        errorElement.style.fontSize = '1.4rem';
        errorElement.style.marginTop = '1rem';
        errorElement.textContent = message;

        const helpText = this.querySelector('.store-pickup-option__help-text');
        if (helpText) {
          helpText.insertAdjacentElement('afterend', errorElement);
        } else {
          this.dateInput.insertAdjacentElement('afterend', errorElement);
        }

        // 5秒後にエラーメッセージを削除
        setTimeout(() => {
          if (errorElement.parentNode) {
            errorElement.remove();
          }
        }, 5000);
      }

      async updateCart(enabled, dateValue) {
        try {
          // 現在のカートのnoteを取得
          const cartResponse = await fetch(`${routes.cart_url}.js`);
          const cartData = await cartResponse.json();
          let currentNote = cartData.note || '';

          // 既存の受取日情報を削除（以前追加されたものを削除するため）
          currentNote = currentNote.replace(/受取日:\s*\d{4}-\d{2}-\d{2}[\s\n]*/g, '').trim();

          // 受取日は注文メモには追加しない（attributesのみに保存）
          const newNote = currentNote;

          // カートを更新（noteとattributesの両方）
          const body = JSON.stringify({
            note: newNote,
            attributes: {
              '店頭受取': enabled ? 'true' : 'false',
              '受取予定日': dateValue || ''
            }
          });

          const response = await fetch(`${routes.cart_update_url}`, {
            ...fetchConfig(),
            ...{ body }
          });

          if (!response.ok) {
            throw new Error('カートの更新に失敗しました');
          }

          // カート更新イベントを発火
          if (window.publish && window.PUB_SUB_EVENTS) {
            const updatedCartData = await response.json();
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'store-pickup',
              cartData: updatedCartData
            });
          }

        } catch (error) {
          console.error('店頭受取情報の更新エラー:', error);
          // エラーメッセージを表示（必要に応じて）
          const errorElement = document.getElementById('cart-errors');
          if (errorElement) {
            errorElement.textContent = '店頭受取情報の更新に失敗しました。もう一度お試しください。';
            setTimeout(() => {
              errorElement.textContent = '';
            }, 5000);
          }
        }
      }
    }
  );
}

